import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initNativeFeatures } from "@/utils/mobile";
import { registerServiceWorker } from "@/utils/serviceWorker";

// Initialize native features for mobile app
initNativeFeatures();

// Register service worker for PWA/offline support
if (process.env.NODE_ENV === 'production') {
  registerServiceWorker().then(registration => {
    if (registration) {
      console.log('Service worker registered for offline support');
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
